module.exports = __webpack_public_path__ + "img/menu-off_01.401ce788.png";